<vb-title [title]="'Title_LogOn' | translate"></vb-title>

<vb-auth-layout>

	<div [hidden]="!status.processing">
		<vb-loading-spinner [msg]="'Loading' | translate" [size]="'large'">
		</vb-loading-spinner>
	</div>

	<div [hidden]="!status.loading">
		<vb-loading-spinner [msg]="'Login_LogoffMessage' | translate" [size]="'large'">
		</vb-loading-spinner>
	</div>

	<div [hidden]="!status.active">

		<div [ngClass]="[authLayoutStyles.centered, authLayoutStyles.logoWrapper]">
			<branding-logo></branding-logo>
		</div>

		<div [ngClass]="authLayoutStyles.heading">
			<h2>{{ 'SignIn' | translate }}</h2>
		</div>

		<form #loginForm="ngForm" [ngClass]="authLayoutStyles.authForm" name="loginForm" (submit)="submit()">

			<div [ngClass]="authLayoutStyles.authMsg" *ngIf="status.statusMessage">{{ status.statusMessage }}</div>

			<div class="margin-top-20">
				<!-- CUSTOM CHANGE -->
				<div style="margin: 0 0 2px 3px; color: #666" id="use-email-login-hint">
					<span class="glyphicons circle_info" style="margin-right: 1ex"></span><span id="use-email-text">Use <span style="text-decoration: underline">FULL E-MAIL ADDRESS</span> for username (e.g. <samp>John.Doe&#64;nd.gov</samp>)</span>
				</div>
				<div class="margin-top-20">
					<label for="username">{{ 'Username' | translate }}</label>
					<input type="text" id="username" name="username" class="form-control theme-header-bg theme-header-txt" [attr.aria-label]="'Username' | translate" [placeholder]="'Username_Placeholder' | translate" [(ngModel)]="formData.username" vbAutoFocus required>
				</div>
				<div class="margin-top-20">
					<label for="password">{{ 'Password' | translate }}</label>
					<input type="password" id="password" name="password" class="form-control theme-header-bg theme-header-txt" [attr.aria-label]="'Password' | translate" [placeholder]="'Password_YourPlaceholder' | translate" [(ngModel)]="formData.password" required>
				</div>

				<div class="margin-top-30">
					<button type="submit" class="btn btn-primary theme-accent theme-accent-txt" [ngClass]="authLayoutStyles.authBtn">
						{{ 'SignIn' | translate }}
					</button>
				</div>

				<div class="margin-top-20 float-right" *ngIf="allowPasswordReset()">
					<a class="theme-header-txt" [uiSref]="'forgot-password'">{{ 'ForgotPasswordNoQuestion' | translate }}</a>
					<!-- CUSTOM CHANGE -->
					<a href="https://selfreg.video.nd.gov" style="margin-left: 2ex" class="theme-header-txt self-registration-link">(Self Registration)</a>
				</div>
			</div>

		</form>

	</div>

</vb-auth-layout>
